export const CATEGORY_ROBOT_DEFAULT_VALUES = {
  cleanup_robot: false,
  cleanup_limit: '100',
};
